import { createContext, useContext } from 'react';

export const WithFavoritesPortalContext = createContext<(element: HTMLDivElement) => void>(
  (element: HTMLDivElement) => element
);

export const useWithFavoritesPortalContext = (): ((element: HTMLDivElement) => void) => {
  return useContext<(element: HTMLDivElement) => void>(WithFavoritesPortalContext);
};
